export const APP_NAME = 'Checkers-Portal'
export const APP_VERSION = '1.0.0'
export const APP_PLATFORM = 'Web'
